const getRadioTypeValues = (
  list: (string | { name: string; type: "checkbox" | "radio" })[]
) => {
  const radioTypeOnly = list.filter((param) => typeof param !== "string") as {
    name: string;
    type: "checkbox" | "radio";
  }[];
  const values = radioTypeOnly.map((param) => param.name);

  return values;
};

export default getRadioTypeValues;
